<template>
  <div class="only-full flex-center common">
    <div class="left">
      <Card v-if="type === 'detail'" :bordered="false">
        <div class="flex" style="align-items: flex-end">
          <div style="width: 50%">
            <div class="agent-name">{{ baseInfo.company }}</div>
            <div class="flex-row mt-20">
              <div class="title-5">联系人姓名</div>
              <div>{{ baseInfo.username }}</div>
            </div>
            <div class="flex-row mt-20">
              <div class="title-5">联系电话</div>
              <div>{{ baseInfo.mobile }}</div>
            </div>
          </div>
          <div class="flex" style="align-items: flex-end">
            <div class="flex-column flex-row">
              <div>
                ￥<count-to
                  :endVal="baseInfo.leftAmount"
                  :decimals="2"
                  class="count-to"
                />
              </div>
              <div>当前余额</div>
            </div>
            <div class="top-divider ml-30 mr-30"></div>
            <div class="flex-column flex-row">
              <div>
                ￥<count-to
                  :endVal="baseInfo.monthIncomeAmount"
                  :decimals="2"
                  class="count-to"
                />
              </div>
              <div>本月收入</div>
            </div>
          </div>
        </div>
      </Card>
      <Card
        title="商户列表"
        :bordered="false"
        :class="'bottom-card' + (type === 'home' ? ' full-card' : ' mt-20')"
      >
        <div slot="extra" class="flex-row">
          <Button
            v-if="tableData.length && type === 'home'"
            class="ml-20 primary-btn"
            type="primary"
            @click="addMerchant"
            >+ 新建</Button
          >
        </div>
        <template v-if="tableData.length || type === 'detail' || tableLoading">
          <div class="table">
            <Table
              :columns="columns"
              :data="tableData"
              :loading="tableLoading"
              stripe
            ></Table>
            <div class="mt-10" style="float: right">
              <Page
                :total="totalCount"
                :current="currentPage"
                :page-size="pageSize"
                size="small"
                @on-page-size-change="pageSizeChange"
                @on-change="pageChange"
                :page-size-opts="[10, 20, 60, 100]"
                show-elevator
                show-sizer
              ></Page>
            </div>
          </div>
        </template>
        <div v-else class="flex-center" style="height: 100%">
          <template v-if="currentType === 'agent'">
            <div class="flex-column flex-row">
              <img
                src="@/assets/merchant_empty.png"
                style="width: 240px; height: 132px"
              />
              <div class="mt-40 no-merchant-tip">
                还没有商户，快去创建一个吧
              </div>
              <Button
                class="mt-30 primary-btn"
                type="primary"
                @click="addMerchant"
                >+ 新建</Button
              >
              <div class="step mt-80 flex">
                <div
                  v-for="(item, index) in stepList"
                  :key="index"
                  class="flex-row"
                  style="position: relative"
                >
                  <img :src="item.url" style="width: 32px; height: 32px" />
                  <div v-if="index < 3" class="step-divider"></div>
                  <div class="step-tip">{{ item.tip }}</div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </Card>
    </div>

    <Card :bordered="false" class="right ml-20">
      <template v-if="type === 'home'">
        <div slot="title" class="card-title">
          我的收入<Tooltip
            content="商户支付金额30%将用于代理提成收入"
            theme="light"
            ><Icon type="ios-help-circle-outline" size="18"
          /></Tooltip>
        </div>
        <div class="flex-center flex-column">
          <div class="amount-tip">可提现余额</div>
          <div class="withdraw-amount">
            ￥<count-to
              :endVal="withdrawalAmount"
              :decimals="2"
              :duration="2000"
              class="income"
            />
          </div>
          <div
            class="mt-10 withdraw-btn flex-center cursor-pointer"
            @click="showWithdraw"
          >
            申请提现
          </div>
        </div>
      </template>
      <div
        v-if="
          (currentType === 'agent' && totalAmount > 0) ||
          (currentType === 'plat' && baseInfo.totalAmount > 0)
        "
        :class="
          'flex flex-around tab-container' + (type === 'home' ? ' mt-30' : '')
        "
      >
        <div
          :class="
            'flex-row flex-column' +
            (recordApi === 'incomeRecord' ? ' selected-tab' : '')
          "
          @click="handleTab('incomeRecord')"
        >
          收入记录
          <div class="tab-extra">
            累计收入：￥{{
              currentType === "agent" ? totalAmount : baseInfo.totalAmount
            }}
          </div>
        </div>
        <div
          :class="recordApi === 'withdrawalRecord' ? 'selected-tab' : ''"
          @click="handleTab('withdrawalRecord')"
        >
          提现记录
        </div>
      </div>
      <div
        :class="'record-container' + (type === 'detail' ? ' full-record' : '')"
      >
        <Spin
          size="large"
          fix
          v-if="spinning"
          class="flex-center spin"
          style="height: 100%"
        ></Spin>
        <div style="height: 100%; overflow: scroll">
          <template v-if="recordList.length">
            <div
              v-for="(item, index) in recordList"
              :key="index"
              :class="
                'record-item flex-row flex-between' +
                (index % 2 === 0 ? '' : ' stripe-item')
              "
            >
              <div>
                <div class="record-top">
                  <template v-if="recordApi === 'incomeRecord'">
                    {{ item.merchantName }}开通服务：{{
                      appName[item.buyAppType]
                    }}
                  </template>
                  <template v-else>收款人：{{ item.receiver }}</template>
                </div>
                <div class="record-bottom">{{ item.date }}</div>
              </div>
              <div>
                <span class="mr-5">+</span
                ><span class="count-to1" style="font-size: 14px">￥</span
                ><count-to
                  :endVal="item.amount"
                  :decimals="2"
                  :duration="1"
                  class="count-to1"
                />
              </div>
            </div>
          </template>
          <div v-else class="flex-center flex-column" style="height: 100%">
            <template
              v-if="recordApi === 'withdrawalRecord' || type === 'detail'"
            >
              <img src="@/assets/empty2.png" class="empty2" />
              <div class="empty-tip mt-20">
                {{
                  recordApi === "withdrawalRecord"
                    ? "暂无提现记录"
                    : "暂无收入记录"
                }}
              </div>
            </template>
            <template v-if="totalAmount === 0 && type === 'home'">
              <img src="@/assets/empty1.png" class="empty1" />
              <div class="empty-tip mt-30">暂无佣金收入</div>
            </template>
          </div>
        </div>
      </div>
      <div v-if="totalAmount > 0" class="mt-10" style="float: right">
        <Page
          :total="totalCount1"
          :current="currentPage1"
          :page-size="pageSize1"
          size="small"
          @on-page-size-change="pageSizeChange1"
          @on-change="pageChange1"
          :page-size-opts="[10, 20, 60, 100]"
          show-sizer
        ></Page>
      </div>
    </Card>

    <Modal
      v-model="withdrawModal"
      title="申请提现"
      width="450"
      :closable="false"
      :mask-closable="false"
    >
      <div class="flex-row">
        <div class="title-5 must">提现金额：</div>
        <a-input-number
          v-model="modalWithdrawalAmount"
          :placeholder="`最多可提现${withdrawalAmount}元`"
          :min="0.01"
          :max="withdrawalAmount"
          :precision="2"
          style="width: 200px"
        />
        <div class="blue-click underline ml-20" @click="allWithdraw">
          全部提现
        </div>
      </div>
      <div class="flex-row mt-20">
        <div class="title-5 must">收款人：</div>
        <Input
          v-model.trim="receiver"
          placeholder="请输入收款人姓名"
          style="width: 200px"
        />
      </div>
      <div class="flex-row mt-20">
        <div class="title-5 must">收款卡号：</div>
        <Input
          v-model.trim="receiveCardNum"
          placeholder="请输入银行卡号"
          style="width: 200px"
          @on-change="getBank"
        />
      </div>
      <div class="flex-row mt-20">
        <div class="title-5 must">收款银行：</div>
        <Select v-model="receiveBank" style="width: 200px" filterable>
          <Option
            v-for="item in bankList"
            :key="item.bankCode"
            :value="item.bankName"
            >{{ item.bankName }}</Option
          >
        </Select>
      </div>
      <div slot="footer">
        <Button @click="cancelWithdraw">取消</Button>
        <Button
          type="primary"
          class="primary-btn"
          @click="saveWithdraw"
          :loading="withdrawLoading"
          >确定</Button
        >
      </div>
    </Modal>

    <Modal
      v-model="addModal"
      title="新建商户"
      :closable="false"
      :mask-closable="false"
      width="420"
    >
      <div class="flex-row">
        <div class="title-4">公司：</div>
        <Input
          v-model.trim="company"
          placeholder="请输入公司名称"
          style="width: 300px"
        />
      </div>
      <div class="flex-row mt-30">
        <div class="title-4">联系人：</div>
        <Input
          v-model.trim="username"
          placeholder="请输入联系人姓名"
          style="width: 300px"
        />
      </div>
      <div class="flex-row mt-30">
        <div class="title-4">手机号：</div>
        <Input
          v-model.trim="mobile"
          placeholder="请输入手机号"
          style="width: 300px"
        />
      </div>
      <div slot="footer">
        <Button @click="cancelAdd">取消</Button>
        <Button
          type="primary"
          class="primary-btn ml-20"
          :loading="addLoading"
          @click="saveAdd"
          >确定</Button
        >
      </div>
    </Modal>

    <Modal v-model="successModal" :closable="false" :mask-closable="false">
      <div class="flex-row flex-column">
        <img src="@/assets/success.png" style="width: 50px" />
        <div class="mt-15 weight-500 size-20">商户创建成功</div>
        <div class="mt-15 success-tip">使用账号登录趣增长商户端</div>
        <div class="success-tip">www.qzz-merchant.cms.yuxisoft.cn/login</div>
        <div class="info-container mt-15">
          <div>公司：{{ successInfo.company }}</div>
          <div>联系人：{{ successInfo.username }}</div>
          <div>手机号：{{ successInfo.mobile }}</div>
        </div>
      </div>
      <div slot="footer" class="flex-center">
        <Button
          type="primary"
          class="primary-btn"
          @click="
            () => {
              this.successModal = false;
            }
          "
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { tableMixin } from "@/mixins";
import countTo from "vue-count-to";
import { getBank } from "@/common/bank";
import { agentApi, platApi } from "@/api";
import { validateMobile } from "@/libs/tools";
import { appName } from "./config";
export default {
  components: { countTo },
  mixins: [tableMixin],
  props: {
    type: {
      type: String,
      default: "home",
    },
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      appName,
      currentType: this.$getCurrentType(),
      columns: [
        {
          title: "公司名称",
          key: "company",
        },
        {
          title: "联系人姓名",
          key: "username",
        },
        {
          title: "手机号",
          key: "mobile",
        },
        {
          title: "已开通应用",
          key: "apps",
        },
        {
          title: "创建时间",
          key: "createdAt",
        },
      ],
      currentPage1: 1,
      pageSize1: 10,
      totalCount1: 0,
      withdrawModal: false,
      bankList: getBank(),
      spinning: false,
      recordList: [],
      stepList: [
        {
          tip: "为创建商户新建账号",
        },
        {
          tip: "商户使用账号登录商户端www.qzz-mercha nt.cms.yuxisoft.cn",
        },
        {
          tip: "商户支付开通服务",
        },
        {
          tip: "代理商获得支付金额30%佣金奖励",
        },
      ],
      addModal: false,
      company: "",
      username: "",
      mobile: "",
      addLoading: false,
      recordApi: "incomeRecord",
      totalAmount: 0,
      withdrawalAmount: 0,
      modalWithdrawalAmount: null,
      receiver: "",
      receiveCardNum: "",
      receiveBank: "",
      withdrawLoading: false,
      baseInfo: {},
      typeApi: {
        home: agentApi,
        detail: platApi,
      },
      successModal: false,
      successInfo: {},
    };
  },

  created() {
    this.stepList = this.stepList.map((item, index) => {
      item.url = require(`../../assets/${index + 1}.png`);
      return item;
    });
  },

  mounted() {
    this.getList();
    this.getInfo();
    if (this.id) {
      this.getBase();
    }
  },

  methods: {
    getBase() {
      platApi.baseInfo({ agentId: this.id }).then((res) => {
        if (res.code === 0) {
          let data = res.result;
          data.leftAmount = this.handleAmount(
            data.totalAmount - data.withdrawalAmount
          );
          data.monthIncomeAmount = this.handleAmount(data.monthIncomeAmount);
          data.totalAmount = this.handleAmount(data.totalAmount);
          this.baseInfo = data;
        }
      });
    },

    async getList() {
      this.tableLoading = true;
      let { currentPage, pageSize, currentType, typeApi, type, id } = this;
      let p = {
        currentPage,
        pageSize,
      };
      if (type === "detail") p.agentId = id;
      let res = await typeApi[type].merchantList(p);
      let { list, totalCount } = res.result;
      this.tableLoading = false;
      this.tableData = list.map((item) => {
        let appList = item.appMchDOList.map((it) => {
          return appName[it.appType];
        });
        item.apps = appList.length ? appList.join(" ") : "-";
        return item;
      });
      this.totalCount = totalCount;
    },

    getList1() {
      let { currentPage1, pageSize1, recordApi, typeApi, type, id } = this;
      let p = {
        currentPage: currentPage1,
        pageSize: pageSize1,
      };
      if (type === "detail") p.agentId = id;
      this.spinning = true;
      typeApi[type][this.recordApi](p).then((res) => {
        this.spinning = false;
        if (res.code === 0) {
          this.recordList = res.result.list.map((item) => {
            item.date = this.$moment(item.createdAt).format(
              "YYYY/MM/DD HH:mm:ss"
            );
            item.amount = this.handleAmount(
              item[recordApi === "incomeRecord" ? "amount" : "withdrawalAmount"]
            );
            return item;
          });
          this.totalCount1 = res.result.totalCount1;
        }
      });
    },

    pageChange1(page) {
      this.currentPage1 = page;
      this.getList1();
    },

    pageSizeChange1(size) {
      this.pageSize1 = size;
      this.currentPage1 = 1;
      this.getList1();
    },

    getInfo() {
      agentApi.getInfo().then((res) => {
        if (this.currentType === "agent") {
          let { totalAmount, withdrawalAmount } = res.result;
          this.totalAmount = this.handleAmount(totalAmount);
          this.withdrawalAmount = this.handleAmount(
            totalAmount - withdrawalAmount
          );
          if (totalAmount > 0) this.getList1();
        } else {
          this.getList1();
        }
      });
    },

    handleAmount(val) {
      return Number((val / 100).toFixed(2));
    },

    getBank() {
      this.$getBankcardinfo.getBankBin(this.receiveCardNum, (err, data) => {
        if (!err) {
          console.log(data);
          this.receiveBank = data.bankName;
        }
      });
    },

    addMerchant() {
      this.addModal = true;
    },

    cancelAdd() {
      this.addModal = false;
      this.company = "";
      this.username = "";
      this.mobile = "";
    },

    saveAdd() {
      let { company, username, mobile } = this;
      try {
        if (!company) throw Error("请输入公司名称");
        if (!username) throw Error("请输入联系人姓名");
        if (!mobile) throw Error("请输入手机号");
        if (!validateMobile(mobile)) throw Error();
      } catch (e) {
        e.message && this.$Message.warning(e.message);
        return;
      }
      let p = {
        company,
        username,
        mobile,
      };
      this.addLoading = true;
      agentApi.addMerchant(p).then((res) => {
        this.addLoading = false;
        if (res.code === 0) {
          this.$Message.success("新建成功");
          this.successInfo = p;
          this.cancelAdd();
          this.successModal = true;
          this.getList();
        }
      });
    },

    handleTab(name) {
      if (name === this.recordApi) return;
      this.recordApi = name;
      this.currentPage1 = 1;
      this.totalCount1 = 0;
      this.getList1();
    },

    showWithdraw() {
      if (!this.withdrawalAmount) {
        this.$Message.warning("暂无可提现金额");
        return;
      }
      this.withdrawModal = true;
    },

    allWithdraw() {
      if (!this.withdrawalAmount) {
        this.$Message.warning("暂无可提现金额");
        return;
      }
      this.modalWithdrawalAmount = this.withdrawalAmount;
    },

    cancelWithdraw() {
      this.withdrawModal = false;
      this.modalWithdrawalAmount = null;
      this.receiver = "";
      this.receiveCardNum = "";
      this.receiveBank = "";
    },

    saveWithdraw() {
      let { modalWithdrawalAmount, receiver, receiveCardNum, receiveBank } =
        this;
      try {
        if (!modalWithdrawalAmount) throw Error("请输入提现金额");
        if (!receiver) throw Error("请输入收款人");
        if (!receiveCardNum) throw Error("请输入收款卡号");
        if (!receiveBank) throw Error("请选择收款银行");
      } catch (e) {
        this.$Message.warning(e.message);
        return;
      }
      let p = {
        withdrawalAmount: Number((modalWithdrawalAmount * 100).toFixed(0)),
        receiver,
        receiveCardNum,
        receiveBank,
      };
      console.log(p);
      this.withdrawLoading = true;
      agentApi.withdrawal(p).then((res) => {
        this.withdrawLoading = false;
        if (res.code === 0) {
          this.$Message.success("申请成功");
          this.getInfo();
          this.cancelWithdraw();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.left {
  width: 900px;
  height: 100%;
}

.bottom-card {
  height: ~"calc(100% - 160px)";
}

.full-card {
  height: 100%;
}

.right {
  width: 400px;
  height: 100%;
  .ivu-card-head {
    height: 52px;
  }
}

.card-title {
  font-size: 16px;
  font-weight: 500;
  color: #17233d;
  line-height: 20px;
}

.table {
  height: ~"calc(100% - 35px)";
}

.income {
  font-size: 44px;
  font-weight: 500;
  color: #000;
}

.agent-name {
  font-size: 20px;
  font-weight: 600;
  color: #17233d;
}

.count-to {
  font-size: 24px;
  font-weight: 600;
  color: #17233d;
}

.record-container {
  position: relative;
  width: 100%;
  height: ~"calc(100% - 250px)";
}

.full-record {
  height: ~"calc(100% - 40px)";
}

.spin {
  position: absolute;
  top: 0;
  left: 0;
}

.record-item {
  padding: 15px 20px;
  height: 97px;
}

.stripe-item {
  background: #f7f7f7;
}

.no-merchant-tip {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}

.step-divider {
  margin: 0 30px;
  width: 100px;
  height: 1px;
  background: #6231d9;
}

.step-tip {
  position: absolute;
  left: -65px;
  top: 50px;
  width: 160px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  text-align: center;
}

.withdraw-amount {
  font-size: 24px;
  font-family: HelveticaNeue-Medium, HelveticaNeue;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}

.amount-tip {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
}

.withdraw-btn {
  width: 100px;
  height: 30px;
  background: #f9f0ff;
  border-radius: 4px;
  border: 1px solid #b99eff;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #6231d9;
  &:hover {
    opacity: 0.8;
  }
}

.tab-container {
  width: ~"calc(100% + 32px)";
  margin-left: -16px;
  border-bottom: 1px solid #e8e8e8;

  div {
    position: relative;
    width: 100px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    cursor: pointer;
    border-bottom: 2px solid transparent;
  }

  .tab-extra {
    bottom: -20px;
    font-size: 8px;
    position: absolute;
    width: 200%;
  }

  .selected-tab {
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #6231d9;
    border-bottom: 2px solid #6231d9;
  }
}

.empty1 {
  width: 230px;
  height: 115px;
}

.empty2 {
  width: 230px;
  height: 150px;
}

.empty-tip {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}

.record-top {
  width: 208px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
}

.record-bottom {
  margin-top: 10px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 17px;
}

.count-to1 {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  line-height: 32px;
}

.success-tip {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
}

.info-container {
  width: 100%;
  height: 99px;
  background: #fafafa;
  border-radius: 3px;
  padding: 20px 40px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 15px;
  div {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}

.top-divider {
  margin-bottom: 4px;
  width: 1px;
  height: 30px;
  background: #e9e9e9;
}
</style>

<style lang="less">
.common {
  .ivu-card-body {
    height: ~"calc(100% - 52px)";
  }

  .ivu-card-head p,
  .card-title {
    &::before {
      content: "|";
      font-weight: 600;
      font-size: 20px;
      color: #613ea4;
      margin-right: 10px;
    }
  }

  .right {
    .ivu-card-head {
      height: 52px;
      padding: 14px 16px;
    }
  }
}
</style>